export default {
      id: "ic_nav_fire-usage",
      viewBox: "0 0 23 30",
      url: "/" + "images/icons.3.109.2.svg#ic_nav_fire-usage",
      toString: function () {
        return this.url;
      }
    }